import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SiteNavComponent } from '../site-nav/site-nav.component';
import { FormsModule } from '@angular/forms';
import { SITE_LINKS } from '../site-links';

@Component({
    selector: 'app-developers',
    standalone: true,
    imports: [CommonModule, RouterModule, FormsModule, SiteNavComponent],
    templateUrl: './developer.component.html',
    styleUrls: ['./developer.component.css']
})
export class DevelopersComponent implements OnInit, OnDestroy {
    readonly links = SITE_LINKS;

    // Base URL for API
    base_url = 'https://web.askbuddy.ai/devspacexdb';

    // Postman pre-request script
    postmanScript = `if (globals['jsrsasign-js'] === undefined) {
    console.log("Downloading jsrsasign library...");
    
    pm.sendRequest({
        url: "http://kjur.github.io/jsrsasign/jsrsasign-latest-all-min.js",
        method: "GET",
        body: {}
    }, function(err, res) {
        postman.setEnvironmentVariable("jsrsasign-js", res.text());
        doHttpSig();
    });
} else {
    doHttpSig();
}

function doHttpSig() {
    var navigator = {};
    var window = {};
    
    eval(postman.getGlobalVariable("jsrsasign-js"));
    
    let pk = postman.getEnvironmentVariable("xdbc-privatekey");
    let pks = pk.split(/\\\\n/);
    let privateKey = "";
    for (let i = 0; i < pks.length; i++) {
        privateKey += pks[i] + "\\n";
    }
    
    var signature_algo = "SHA256withECDSA";
    var payload = request.data;
    
    var sig = new KJUR.crypto.Signature({
        "alg": signature_algo
    });
    sig.init(privateKey);
    
    var reqBody = JSON.parse(payload);
    pm.request.body.raw = JSON.stringify(reqBody);
    var payloadFmt = JSON.stringify(reqBody);
    sig.updateString(payloadFmt);
    
    var sigValueHex = sig.sign();
    var sigBase64 = hextob64(sigValueHex);
    
    var apiKey = postman.getEnvironmentVariable("xdbc-apikey");
    pm.request.headers.add({ key: "apiKey", value: apiKey });
    pm.request.headers.add({ key: "signature", value: sigBase64 });
}`;


    // Search
    searchQuery = '';

    // Sidebar section expansion state
    expandedSections: { [key: string]: boolean } = {
        'overview': true,
        'memories': true,
        'tags': true,
        'skills': true
    };

    // Active section for scroll spy
    activeSection = 'introduction';

    // Active tabs for response examples
    activeTab: { [key: string]: string } = {
        'register': 'success',
        'activate': 'success',
        'memory': 'success'
    };

    // Clipboard feedback
    copiedText = '';

    private scrollHandler: any;

    constructor() { }

    ngOnInit(): void {
        this.scrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    ngOnDestroy(): void {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
        }
    }

    @HostListener('window:scroll')
    onScroll(): void {
        this.updateActiveSection();
    }

    updateActiveSection(): void {
        const sections = [
            'introduction', 'authentication', 'signature-generation', 'postman-setup', 'python-sdk', 'base-url', 'response-format',
            'create-memory', 'memory-status', 'list-memories',
            'chat', 'summarize-memory', 'forget-memory',
            'list-tags', 'add-tag', 'get-by-tag', 'change-tag', 'health',
            'skills-overview', 'openclaw'
        ];

        const scrollPosition = window.scrollY + 150;

        for (const sectionId of sections) {
            const element = document.getElementById(sectionId);
            if (element) {
                const offsetTop = element.offsetTop;
                const offsetHeight = element.offsetHeight;

                if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                    this.activeSection = sectionId;
                    break;
                }
            }
        }
    }

    toggleSection(section: string): void {
        this.expandedSections[section] = !this.expandedSections[section];
    }

    scrollToSection(event: Event, sectionId: string): void {
        event.preventDefault();
        event.stopPropagation();

        const element = document.getElementById(sectionId);
        if (element) {
            // CSS scroll-margin-top handles the header offset
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            this.activeSection = sectionId;
        }
    }

    setActiveTab(endpoint: string, tab: string): void {
        this.activeTab[endpoint] = tab;
    }

    filterEndpoints(): void {
        // Could implement endpoint filtering based on searchQuery
        // For now, this is a placeholder for search functionality
        console.log('Filtering for:', this.searchQuery);
    }

    copyToClipboard(text: string): void {
        navigator.clipboard.writeText(text).then(() => {
            this.copiedText = text;
            setTimeout(() => {
                this.copiedText = '';
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    }

    copyCode(elementId: string): void {
        const element = document.getElementById(elementId);
        if (element) {
            const text = element.textContent || '';
            this.copyToClipboard(text);
        }
    }
}